import { render } from "./HomeView.vue?vue&type=template&id=67d846ab&scoped=true&lang=pug"
import script from "./HomeView.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeView.vue?vue&type=script&setup=true&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=67d846ab&lang=scss&scoped=true"

import exportComponent from "/Users/jon.bloom/Documents/Clients/Freshwater/ise-ds-awards-2022-microsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d846ab"]])

export default __exports__